<template lang="pug">
  div.fill-height
    SubHeader
    Informarion(
      v-for='(about, i) in abouts',
      :key='i',
      :title='about.title',
      :text='about.text',
      :subtext='about.subtext',
      :list='about.list'
    )
</template>

<script>
// @ is an alias to /src
import SubHeader from '@/components/SubHeader.vue'
import Informarion from '@/components/Information.vue'

export default {
  name: 'About',
  components: {
    SubHeader,
    Informarion,
  },
  data() {
    return {
      abouts: [
        {
          title: 'NOSOTROS',
          text: 'Somos una  compañía innovadora que llego al mercado brindando diferentes soluciones de identificación animal con productos reconocidos por sus altos estándares de calidad y excelente servicio y asesoría al cliente.',
          subtext: 'Somos una empresa totalmente comprometida con labores de ayuda a los animales, que actúa ante casos de maltrato e indiferencia hacia ellos, es por esto que incentivamos y fomentamos los actos de rescate animal, apoyamos y promovemos jornadas de adopción y esterilización ya que creemos esto como la principal solución hacia la sobrepoblación de animales.',
          list: []
        },
        {
          title: 'MISIÓN',
          text: 'MicroPet ID, es una compañía que ofrece diferentes soluciones  de identificación animal. Busca incentivar y concientizar a las personas acerca de la  importancia de  tener identificado sus animales. Nuestra tecnología permite disminuir el índice de perdida, ya que su propósito es tener información amplia y accesible del animal.',
          subtext: '',
          list: []
        },
        {
          title: 'VISIÓN',
          text: 'Ser pioneros en ofrecer, la más completa solución de identificación y seguimiento animal, disminuyendo así el índice de pérdidas de animales.',
          subtext: '',
          list: []
        },
        {
          title: 'Fundaciones',
          text: 'Beneficiar fundaciones y organizaciones que fomenten la adopción , esterilización, concientizacion y rescate animal.',
          subtext: 'Tecnologia: Ser pionero en el desarrollo de nuevas soluciones tecnológicas, que permitan la identificación y seguimiento animal.\nDistribuidores: Brindar nuevas plataformas tecnológicas, que faciliten la introducción y acceso a la información clínica del animal.\nFamilia: Ser los mejores aliados de las familias brindando seguridad y la confianza de que sus mascotas siempre permanecerán con ellos.',
          list: [
            {text: 'Facilitando el seguimiento y acceso a los animales adoptados.' },
            {text: 'Promoviendo y difundiendo jornadas de Esterilización, adopción, acopio de donaciones, etc.' },
            {text: 'Realizando y respaldando eventos de concientización y educación sobre la tenencia responsable de mascotas.' }
          ]
        }
      ]
    }
  },
}
</script>
